import { Link as RouterLink } from "react-router-dom";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PlaceIcon from "@mui/icons-material/Place";
import { useTheme } from "@mui/material/styles";

const MissionCard = (props) => {
  const theme = useTheme();


  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        border: "1px solid rgba(6, 57, 112, 0.1)",
        boxShadow: "0 14px 38px rgba(6, 57, 112, 0.1)",
        transition: "transform 220ms ease, box-shadow 220ms ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 24px 60px rgba(6, 57, 112, 0.18)",
        },
        "&:hover .mission-media": {
          transform: "scale(1.05)",
        },
      }}
    >
      <CardActionArea
        component={RouterLink}
        to={props.destination}
        sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ position: "relative", width: "100%", overflow: "hidden" }}>
          <CardMedia
            component="img"
            className="mission-media"
            sx={{
              height: 260,
              objectFit: "cover",
              transition: "transform 420ms ease",
            }}
            image={props.imgUrl}
            alt={props.title}
            loading="lazy"
            decoding="async"
          />
          <Chip
            label={props.status}
            size="small"
            sx={{
              position: "absolute",
              top: 14,
              left: 14,
              color: theme.palette.common.white,
              bgcolor:
                props.status === "Upcoming"
                  ? theme.palette.donate.secondary
                  : "#15803d",
              fontWeight: 800,
            }}
          />
        </Box>
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            width: "100%",
            p: 2.25,
          }}
        >
          <Typography component={props.headingLevel || "h3"} gutterBottom variant="h5" sx={{ fontWeight: 900 }}>
            {props.title}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 1 }}>
            <PlaceIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              {props.location} · {props.date}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", lineHeight: 1.65, flexGrow: 1 }}
          >
            {props.description}
          </Typography>
          <Button
            component="span"
            tabIndex={-1}
            role={undefined}
            endIcon={<ArrowForwardIcon />}
            sx={{ mt: 2, alignSelf: "flex-start" }}
          >
            More info
          </Button>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default MissionCard;
